import { PromiseQueueItem } from './promise-queue-item'

export class PromiseQueue {
  queue: Set<PromiseQueueItem> = new Set()

  public add (item: PromiseQueueItem) {
    this.queue.add(item)
  }

  public resolveAll () {
    this.queue.forEach(({ resolve }) => {
      resolve()
    })
    this.queue.clear()
  }

  public rejectAll () {
    this.queue.forEach(({ reject }) => {
      reject()
    })
    this.queue.clear()
  }
}
